export default function translationsConfig($translateProvider) {
  $translateProvider.translations('en', englishTranslations());
  $translateProvider.translations('jp', japaneseTranslations());
  $translateProvider.useSanitizeValueStrategy(null);
  $translateProvider.preferredLanguage('en');

  function englishTranslations() {
    return {
      AD_TYPE: 'Ad Type',
      AD_UNIT: 'Ad Unit',
      ADVANCED_SETTINGS: 'Advanced Settings',
      BACK: 'Back',
      BRAND: 'Brand',
      BRAND_NAME: 'Brand Name',
      BRAND_LOGO_URL: 'Brand Logo URL',
      BUILD_NATIVE_AD: 'Create New Ad',
      CANCEL: 'Cancel',
      MEDIA_URL: 'Clickout URL',
      COPYRIGHT: '© 2021 Sharethrough All Rights Reserved',
      COPY: 'Copy',
      COPIED: 'Copied',
      COPY_TO_CLIPBOARD: 'Copy to Clipboard',
      CREATE_NEW_DEMO: 'Create New Ad',
      CREATIVE: 'Creative',
      CUSTOM_BUTTON_TEXT: 'Button Text (Optional)',
      CUSTOM_BUTTON_URL: 'Button Clickout URL (Optional)',
      DCO_URL: 'DCO URL',
      DEMO_NAME: 'Ad Name',
      DESCRIPTION: 'Description',
      DESCRIPTION_STRING_LENGTH_ERROR:
        'Description must be 200 characters or less.',
      DESKTOP: 'Desktop',
      DSP_CUSTOM_BUTTON_URL: 'Button Click URL/Tracker (Optional)',
      ENGAGEMENT_TRACKER: 'Engagement Tracker',
      EXAMPLES: 'Examples',
      GO: 'Pull Content',
      HEADLINE: 'Headline',
      HEADLINE_STRING_LENGTH_ERROR: 'Headline must be 90 characters or less',
      HOME: 'Home',
      INVALID_YOUTUBE_URL: 'Please use a valid YouTube URL',
      ISI_DISPLAY: 'ISI Display',
      ISI_VIDEO: 'ISI Video',
      LEARN_MORE: 'Learn More',
      LOGIN: 'Login',
      MOBILE: 'Mobile',
      NAME_YOUR_DEMO: 'Name Your Ad',
      NATIVE_DCO_DISPLAY: 'Dynamic Native',
      NATIVE_DISPLAY: 'Native Display',
      NATIVE_ISI: 'Native ISI',
      PROCESSING_VIDEO_MESSAGE:
        "This creative's video is currently being processed.",
      SAVE: 'Save',
      SCROLLER: 'Scroller',
      SHAREABLE_VIEW_LINK: 'Shareable View Link',
      SIGN_UP: 'Sign Up',
      SLIDESHOW: 'Thumbnail Carousel',
      TABLET: 'Tablet',
      THUMBNAIL_URL: 'Thumbnail URL',
      VIDEO_START: 'Video Start Tracker (1x1)',
      YOUTUBE_URL: 'YouTube URL'
    };
  }

  function japaneseTranslations() {
    return {
      AD_TYPE: '広告タイプ選択に戻る',
      AD_UNIT: '広告ユニット選択に戻る',
      ADVANCED_SETTINGS: '詳細設定',
      BACK: '戻る',
      BRAND: 'ブランド',
      BRAND_NAME: 'ブランド',
      BRAND_LOGO_URL: 'ブランドロゴURL',
      BUILD_NATIVE_AD: 'ネイティブ広告を作成',
      CANCEL: 'キャンセル',
      MEDIA_URL: 'クリックアウトURL',
      COPYRIGHT: '技術供給 - Sharethrough, Inc.',
      COPY: 'コピー',
      COPIED: 'コピーされた',
      COPY_TO_CLIPBOARD: 'クリップボードにコピー',
      CREATE_NEW_DEMO: '新規デモ作成',
      CREATIVE: 'クリエイティブ',
      CUSTOM_BUTTON_TEXT: 'カスタムボタンテキスト',
      CUSTOM_BUTTON_URL: 'カスタムボタンURL',
      DCO_URL: 'DCO URL',
      DEMO_NAME: 'デモタイトル',
      DESCRIPTION: '説明',
      DESCRIPTION_STRING_LENGTH_ERROR:
        '説明は140文字以下にする必要があります。',
      DESKTOP: 'デスクトップ',
      DSP_CUSTOM_BUTTON_URL: 'Button Click URL/Tracker (Optional)',
      ENGAGEMENT_TRACKER: 'エンゲージメントトラッカー',
      EXAMPLES: '例',
      GO: 'コンテンツを取得する',
      HEADLINE: 'ヘッドライン',
      HEADLINE_STRING_LENGTH_ERROR:
        'ヘッドラインは90文字以下にする必要があります。',
      HOME: 'ホーム',
      IMPRESSION_TRACKER: 'Impression Tracker',
      ISI_DISPLAY: '安全に関する重要な注意事項ディスプレイ',
      ISI_VIDEO: '安全に関する重要な注意事項ビデオ',
      INVALID_YOUTUBE_URL: 'Please use a valid YouTube URL',
      LEARN_MORE: 'さらに詳しく',
      LOGIN: 'ログイン',
      MOBILE: 'モバイル',
      NAME_YOUR_DEMO: 'デモに名前を付ける',
      NATIVE_DCO_DISPLAY: '動的なネイティブ',
      NATIVE_DISPLAY: 'ネイティブディスプレイ',
      NATIVE_ISI: 'ネイティブ安全に関する重要な注意事項',
      PROCESSING_VIDEO_MESSAGE: 'この動画は現在処理中です。',
      SAVE: '保存',
      SCROLLER: 'スクロール',
      SHAREABLE_VIEW_LINK: '共有可能な閲覧用リンク',
      SIGN_UP: '登録',
      SLIDESHOW: 'スライドショー',
      TABLET: 'タブレット',
      THUMBNAIL_URL: 'サムネイルURL',
      VIDEO_CARD: '動画リッチメディア',
      VIDEO_START: 'ビデオ開始',
      YOUTUBE_URL: 'YouTube URL'
    };
  }
}

translationsConfig.$inject = ['$translateProvider'];
